/* rp-wyg-gallery.js: "What you get" cards follow the selected option on the product page gallery.
   Insert Only selected (default): the insert-only card is shown, the insert + case card is hidden.
   Insert + PACKOUT Case selected: the case card is shown, the insert-only card is hidden, and the gallery goes back to the first product photo.
   Cards are recognised by their image alt text. Products without these cards, and pages without the media gallery, are left alone. */
(function () {
  var gallery = document.querySelector('media-gallery');
  if (!gallery) return;
  var CASE_ALT = 'and one milwaukee packout case', CARD_ALT = 'what you get: one insert';

  function withCase() {
    var on = false;
    document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (r) {
      var v = (r.value || '').toLowerCase();
      if (v.indexOf('yes') === 0 || v.indexOf('insert +') > -1) on = true;
    });
    var sel = document.querySelector('variant-selects select');
    if (sel && sel.options && sel.selectedIndex > -1) {
      var t = (sel.options[sel.selectedIndex].text || '').toLowerCase();
      if (t.indexOf('yes') === 0 || t.indexOf('insert +') > -1) on = true;
    }
    return on;
  }
  function kind(item) {
    var img = item.querySelector('img');
    var alt = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
    if (alt.indexOf(CASE_ALT) > -1) return 'case';
    if (alt.indexOf(CARD_ALT) > -1) return 'insert';
    return '';
  }
  function setHidden(item, hide) {
    if (hide) { item.setAttribute('hidden', ''); item.style.display = 'none'; }
    else { item.removeAttribute('hidden'); item.style.display = ''; }
  }
  function apply(resetToFirst) {
    var wc = withCase();
    var items = gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id], [id^="GalleryThumbnails"] li[data-target]');
    var found = false;
    items.forEach(function (li) {
      var k = kind(li);
      if (!k) return;
      found = true;
      setHidden(li, k === 'case' ? !wc : wc);
    });
    if (!found || !resetToFirst) return;
    var first = gallery.querySelector('[id^="GalleryViewer"] li[data-media-id]:not([hidden])');
    if (first && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(first.dataset.mediaId, false);
  }

  apply(false);
  var selects = document.querySelector('variant-selects');
  if (selects) {
    selects.addEventListener('change', function () {
      apply(false);
      [150, 600, 1400].forEach(function (ms) { setTimeout(function () { apply(true); }, ms); });
    });
  }
  // keep the state if the theme re-renders the gallery
  try {
    var mo = new MutationObserver(function () { mo.disconnect(); apply(false); mo.observe(gallery, { childList: true, subtree: true }); });
    mo.observe(gallery, { childList: true, subtree: true });
  } catch (e) { /* no observer, first apply still ran */ }
})();
